import { render, staticRenderFns } from "./DiceRoller.vue?vue&type=template&id=21d9f41a&scoped=true&"
import script from "./DiceRoller.vue?vue&type=script&lang=js&"
export * from "./DiceRoller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d9f41a",
  null
  
)

export default component.exports